// @flow
import { windowStates } from 'catena/er2_map_userlayers/js/components/window_state'
import type { WindowStateType } from 'catena/er2_map_userlayers/js/components/window_state'
import * as actionTypes from '../constants/action_types'

export type RefugeeModelType = {
    visible: boolean,
    displayStatistics: boolean,
    // Ascii grid definition
    grid: string,
    windowState: WindowStateType,
}

type RefugeeActionType = {
    type: string,
    grid: {},
    windowState: WindowStateType,
}

const initialState = {
    visible: true,
    displayStatistics: false,
    grid: '',
    windowState: windowStates.opened,
}

export default function refugeeModel(state: RefugeeModelType = initialState, action: RefugeeActionType) {
    let newstate = state
    if (action.type === actionTypes.UPDATE_REFUGEE_GRID) {
        newstate = { ...state, grid: action.grid }
    } else if (action.type === actionTypes.REFUGEE_MODEL_DISPLAY_STATISTICS) {
        newstate = { ...state, displayStatistics: true }
    } else if (action.type === actionTypes.REFUGEE_MODEL_WINDOW_STATE) {
        newstate = { ...state, windowState: action.windowState }
    }
    return newstate
}
